module.exports = __webpack_public_path__ + "sgby/img/normal-point.e186d3c.png";